import { TRoute } from "../types.js";

export const tenantDetailsRoute: TRoute<null, { tenantKey: string }> = {
  path: "/tenants/:tenantKey",
  redirect: ({ tenantKey }) => ({
    to: `/tenants/${tenantKey}/overview`,
    replace: true,
  }),
};
